import { Divider, Skeleton, Stack } from "@mui/material";

export const SearchResultCardSkeleton = () => {
    const fakeKeyFigures: { key: number; labelWidth: number; valueWidth: number }[] = [
        { key: 1, labelWidth: 170, valueWidth: 48 },
        { key: 2, labelWidth: 124, valueWidth: 98 },
        { key: 3, labelWidth: 114, valueWidth: 84 },
        { key: 4, labelWidth: 128, valueWidth: 82 },
        { key: 5, labelWidth: 144, valueWidth: 101 },
    ];

    return (
        <Stack direction="column" sx={{ boxShadow: 3, borderRadius: "8px", p: [2, 3] }}>
            <Stack direction="row" sx={{ mb: 4, flexGrow: 1, overflow: "hidden" }}>
                <Skeleton variant="circular" width={48} height={48} sx={{ flexShrink: 0, mr: 1 }} />
                <Stack direction="column">
                    <Skeleton variant="rectangular" width={178} height={16} sx={{ mt: 0.5, mb: 1 }} />
                    <Skeleton variant="rectangular" width={100} height={16} />
                </Stack>
            </Stack>
            <Stack sx={{ height: ["121px", "127px", "117px", "140px"], mb: 2 }} />
            <Stack divider={<Divider sx={{ borderColor: "gray.100" }} />} spacing={0} sx={{ width: "100%", mb: 2 }}>
                {fakeKeyFigures.map(({ key, labelWidth, valueWidth }) => (
                    <Stack key={key} direction="row" sx={{ justifyContent: "space-between", alignItems: "center", width: "100%", height: 48 }}>
                        <Skeleton variant="rectangular" width={labelWidth} height={16} />
                        <Skeleton variant="rectangular" width={valueWidth} height={16} />
                    </Stack>
                ))}
            </Stack>
            <Stack direction="row">
                <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: "8px" }} />
                <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: "8px", ml: 2 }} />
            </Stack>
        </Stack>
    );
};
